import { useState, useMemo } from 'react';

const usePagination = (items = [], defaultPageSize = 5) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  // Calculate paginated data only when dependencies change
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return items.slice(startIndex, endIndex);
  }, [items, currentPage, pageSize]);

  // Handle page and size changes
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setCurrentPage(1); // Reset to first page when changing page size
  };

  return {
    // Data
    paginatedData,
    total: items.length,
    
    // State
    currentPage,
    pageSize,
    
    // Handlers
    handlePageChange,
    handlePageSizeChange
  };
};

export default usePagination;